import {
  variables,
  __,
  el,
  SelectControl,
} from '../../common/variables';
import { cl } from '../../common/functions';

const editTypes = (props) => {
  const { className, isSelected, attributes, setAttributes, setMetaValue } = props;

  const makeTypesOption = (types) => {
    const typeArray = [];
    if (types.length !== 0) {
      typeArray.push({ label: __('Tous'), value: 'all' });
      types.forEach(type => {
        typeArray.push({ label: __(`${type.types_name}`), value: type.types_name.toLowerCase() });
      });
    }
    return typeArray;
  }

  return el(SelectControl,
    {
      multiple: true,
      label: __('Selectionner les types de commerce à afficher'),
      title: __('Selectionner les types de commerce à afficher'),
      className: "select-box",
      options: makeTypesOption(variables.types),
      value: attributes.types,
      onChange: (value) => {
        setAttributes({ types: value });
      },
      onFocus: (e) => {
        const thisElement = e.target;
        const label = thisElement.parentNode.parentNode.querySelector('label');
        if (label) {
          label.classList.add('select-focused');
        }
      },
      onBlur: (e) => {
        const thisElement = e.target;
        const label = thisElement.parentNode.parentNode.querySelector('label');
        if (label) {
          label.classList.remove('select-focused');
        }
      }
    }
  )
}

export { editTypes }
